import React from 'react'
import { TreeSelect, TreeListItem, Tag, Label } from '@runeffective/evo-design-system'
import { useAppData } from '@providers'
import { IDepartmentBase } from '@api'

import { ColorSquare } from '@ui'
import cx from 'classnames'
import css from '../UI/selects/departmentSelect.module.scss'
import { ISelectedItemType } from '@runeffective/evo-design-system/components/TreeSelect/TreeSelect.types'

type DepartmentTeamsItem = IDepartmentBase & {
  isTeam?: boolean
}

const EvoTreeSelect = ({
  value,
  onChange,
}: {
  value: any
  onChange: (department: any) => void
}) => {
  const { departments } = useAppData()

  const departmentItems = departments?.reduce<DepartmentTeamsItem[]>(
    (previousValue, currentValue) => {
      const { teams: rawTeams, ...value } = currentValue
      const teams = rawTeams.map((item) => ({ ...item, isTeam: true }))
      return [...previousValue, { ...value, isTeam: false }, ...teams]
    },
    []
  )

  const handleItemSelect = (item: ISelectedItemType) => {
    const { id, title } = item
    onChange({ id, name: title })
  }

  return (
    <>
      <TreeSelect
        selectedItem={{
          title: value?.name || 'N/A',
          parentTitle: value?.name || 'N/A',
          parentNodeIds: [],
          id: value?.id || '',
        }}
        textFieldProps={{ placeholder: 'Select Department' }}
        includeChildrenOfSearchedParents
        onItemSelected={handleItemSelect}
      >
        {departmentItems?.map((item) => {
          const { color, isTeam, name, id } = item
          return (
            <div
              key={id}
              className={cx({
                [css.departments_item]: !isTeam,
                [css.teams_item]: isTeam,
              })}
            >
              <div className="flex flex-col justify-center flex-grow truncate">
                <div className="flex justify-between" title={name}>
                  <TreeListItem
                    parentTitle={name}
                    title={name}
                    id={id}
                    color={color}
                    nodeId={id}
                    leftIcon={<ColorSquare style={{ background: `#${color}` }} />}
                  />
                  {isTeam && <Tag className={css.team_tag} title="Team" variant="Normal" />}
                </div>
              </div>
            </div>
          )
        })}
      </TreeSelect>
    </>
  )
}

export default EvoTreeSelect
